<template>
    <div class="foot" v-if="$isApproveShow()">
        <div class="footLeft">
            <van-icon v-show="totalNum" name="https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20210106/bc30e334-218a-47a4-844e-89f72c1fc082.png" :info="totalNum" />
            <van-icon v-show="!totalNum" name="https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20210106/bc30e334-218a-47a4-844e-89f72c1fc082.png" />
            <div class="price" v-show="totoalMoney"><span>¥</span>{{ totoalMoney | NumFormat }}</div>
        </div>
        <div class="footRight">
            <div class="btn" @click="handleSubmit">去结算</div>
        </div>
    </div>
    <div class="approve" v-else>
        <div class="btn" @click="onPen">认证后可购买</div>
    </div>
</template>

<script>
export default {
    props: {
        totalNum: {
            type: Number,
            default: 0
        },
        totoalMoney: {
            type: Number,
            default: 0
        }
    },
    methods: {
        handleSubmit () {
            this.$emit('handleSubmit')
        },
        onPen () {
            this.$router.push({ path: '/b2b/company/index' })
        }
    }
}
</script>

<style lang="scss" scoped>
.foot {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 32px;
    .footLeft{
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 32px;
        .price{
            margin-left: 32px;
            span{
                font-size: 24px;
                padding-right: 6px;
            }
        }
    }
    .btn{
        width: 208px;
        height: 64px;
        line-height: 64px;
        border-radius: 64px;
        text-align: center;
        font-size: 28px;
        background: #FF7A45;
        color: #ffffff;
    }
}
.approve {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    padding: 32px;
    z-index: 99;
    .btn {
        width: 100%;
        height: 90px;
        line-height: 90px;
        font-size: 34px;
        text-align: center;
        border-radius: 90px;
        color: #ffffff;
        background: #ff4d4f;
        &.active {
            background: #ccc;
        }
    }
}
/deep/ .van-icon{
    font-size: 70px;
}
/deep/ .van-info {
    border: none;
    font-size: 24px;
    line-height: 34px;
    min-width: 40px;
    top: 6px;
}
</style>